

import { useState, useEffect } from "react"
import { Input } from "../../components/input.js"
import { Button } from "../../components/button.js"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/select.js"
import axios from "axios"

type Props = {
  onSubmit: (data: any) => void
  initialValues?: any
  isEdit?: boolean
}

export function SubCategoryForm({ onSubmit, initialValues = {}, isEdit = false }: Props) {
  const [form, setForm] = useState({
    name: initialValues?.name || "",
    status: initialValues?.status || "1",
    category_id: initialValues?.category_id || "",
    code: initialValues?.code || "",
  });
  const [categories, setCategories] = useState<any[]>([])

  useEffect(() => {
    axios.get("http://localhost:4000/api/category")
      .then(res => setCategories(res.data?.data || []))
      .catch(err => {
        setCategories([])
        console.error("Failed to fetch categories", err)
      })
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleStatusChange = (value: string) => {
    setForm({ ...form, status: value })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const {
      name,
    } = form;

    const errors = [];

    if (!name) errors.push("Name is required.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }
    
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 py-4">
      <label className="block mb-2 font-medium">Category</label>
      <select
        name="category_id"
        value={form.category_id}
        onChange={handleChange}
        required
        className="w-full border p-2 rounded mb-2"
      >
        <option value="">Select Category</option>
        {(categories || []).map((category: any) => (
          <option key={category.category_id} value={category.category_id}>
            {category.name}
          </option>
        ))}
      </select>
      <Input name="name" placeholder="Name" value={form.name} onChange={handleChange} />
      <Input name="code" placeholder="Code" value={form.code} onChange={handleChange} />

      <Select value={form.status} onValueChange={handleStatusChange}>
        <SelectTrigger>
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Enabled</SelectItem>
          <SelectItem value="0">Disabled</SelectItem>
        </SelectContent>
      </Select>

      <Button type="submit">{isEdit ? "Update SubCategory" : "Add Sub Category"}</Button>
    </form>
  )
}
